import { put, call, takeLatest, all } from "redux-saga/effects";
import { toast } from "react-toastify";
import { BASE_BACKEND_URL } from "../constant";

// Action Types
export const GET_CONFIG_DATA_REQUEST = "GET_CONFIG_DATA";
export const GET_CONFIG_DATA_SUCCESS = "GET_CONFIG_DATA_SUCCESS";
export const GET_CONFIG_DATA_FAILURE = "GET_CONFIG_DATA_FAILURE";

// Action Creators
// export const getConfigData = (hash) => ({
//   type: GET_CONFIG_DATA_REQUEST,
//   payload: { hash },
// });

// API Call Function
const getConfigDataAPI = async (hash) => {

  const token = localStorage.getItem("accessToken");

  // Redirect to login if token is absent
  if (!token) {
    return;
  }
  const response = await fetch(
    `${BASE_BACKEND_URL}/user/user-credentials/get-config/?hash=${hash}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
      method: "GET",
    }
  );
  if (response.status === 401) {
    // Handle unauthorized access by deleting the token, notifying the user, and redirecting
    localStorage.removeItem("accessToken"); // Remove the token
    toast.error("Session expired. Please log in again.", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    return;
  }
  if (!response.ok) {
    toast.error("Error fetching configuration data", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    throw new Error("Error fetching configuration data");
  }

  const data = await response.json();
  return data;
};

// Worker Saga
function* getConfigDataWorker(action) {
  try {
    const { hash } = action.payload;
    const data = yield call(getConfigDataAPI, hash || localStorage.getItem("storedHash"));
    yield put({ type: GET_CONFIG_DATA_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: GET_CONFIG_DATA_FAILURE, payload: error.message });
  }
}

// Watcher Saga
function* getConfigDataWatcher() {
  yield takeLatest(GET_CONFIG_DATA_REQUEST, getConfigDataWorker);
}

// Root Saga
export default function* rootSaga() {
  yield all([getConfigDataWatcher()]);
}
